export default __webpack_public_path__ + "static/step_thumb-303312454125feee9a323b3e6874c0d0.png";